import http from './http'

const basePath = '/Telas/AgendaParcelas'

export default {
  async getPaged (params) {
    const response = await http.get(`${basePath}/GetPaged`, { params })
    return response.data
  },
  async getOptions () {
    const response = await http.get(`${basePath}/GetOptions`)
    return response.data
  }
}
